import { API } from "aws-amplify";
import {
  resolveLambdaFacilityId,
  resolveCorporateFacilityIdForRequest,
  withSelectedCorporateFacId,
} from "./facilityLambdaHelpers";


 export const getRestaurantsList=async(FacilityId,throwOnError=false)=>{
    const facilityId = await resolveLambdaFacilityId(FacilityId);
    if (!facilityId) {
      return [];
    }
    // Fixed: was passing `facilityId` (any user's own facility) as the
    // selectedCorporateFacId marker too — that field is only meant for
    // actual corporate users. See docs/signage/corporate-facility-id-fix.md.
    const corporateFacilityId = await resolveCorporateFacilityIdForRequest(FacilityId);
    let RestaurantsList=[];
    let pagesize=100;
    let responcesize=100;
    let pagenumber=1;
    while(responcesize===pagesize)
    {
        const RequestBody=withSelectedCorporateFacId({
          Filter: {
                AssetType: "Restaurant",
				Facility: facilityId
          },
          pagingSorting: {
            page_no: pagenumber,
            page_size: pagesize,
          }
        }, corporateFacilityId);
        try {
          const response = await API.post('lambda', '/assets/list', {
            body:RequestBody,
          });
        // console.log("Resturants list  is "+JSON.stringify(response));

        // A facility without dining configuration answers 200 with Success:false and no Result: treat it as "no restaurants".
        const resturants=Array.isArray(response?.Content?.Result)?response.Content.Result:[];
        for(let resturantitem of resturants)
        {
            RestaurantsList.push({value:resturantitem._id,label:resturantitem.AssetName});
        }
        responcesize=resturants.length;
        pagenumber++;
        
       
        } catch (error) {
          console.log("Something went wrong while Fetching Resturants  list"+error.message);
          if(throwOnError) throw error;
          break;
    }
}
    return RestaurantsList;
      }